import { Box, CircularProgress } from '@mui/material';

export const SpinnerLoading = () => {
    return (
        <Box sx={{ display: 'flex' }}>
            <CircularProgress aria-label="Loading…" />
        </Box>
    )
}
